import React from "react";
import { brand } from "../mock";

export default function Footer() {
  return (
    <footer className="border-t border-white/[0.06] py-10">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-6 sm:flex-row">
        <div className="flex items-center gap-2.5">
          <span className="h-5 w-5 rounded-full bg-gradient-to-br from-violet-300 to-violet-500" />
          <span className="font-display text-[15px] text-white">
            Duplica <span className="text-white/50 font-medium">tus Ventas</span>
          </span>
        </div>
        <p className="text-[13px] text-white/40">
          © {new Date().getFullYear()} {brand.name}. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}
